// extracted by mini-css-extract-plugin
module.exports = {"committeeStatus":"CommitteeStatus_committeeStatus__1ITH1","activeStatus":"CommitteeStatus_activeStatus__35hGC","archivedStatus":"CommitteeStatus_archivedStatus__VLo8G"};